import TemporaryWeightHackedGraph from './TemporaryWeightHackedGraph'

export default TemporaryWeightHackedGraph



// WEBPACK FOOTER //
// ./src/legacy/containers/Graphs/TemporaryWeightHackedGraph/index.js